/* OpenClaw Hero CTA A/B + tracking */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function track(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload || {});
      }
    } catch (e) {}
  }

  ready(function () {
    var heroButtons = document.querySelectorAll('main .banner .banner__buttons a.button');
    if (!heroButtons || !heroButtons.length) return;

    var primary = heroButtons[0];
    var variantKey = 'oc_hero_cta_variant_v1';
    var variant = localStorage.getItem(variantKey);
    if (!variant) {
      variant = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(variantKey, variant);
    }

    var variants = {
      A: {
        label: 'Jetzt entdecken',
        href: '/collections/all?utm_source=hero&utm_campaign=deals_der_woche&utm_content=cta_A'
      },
      B: {
        label: 'Deals sichern',
        href: '/collections/deals-der-woche?utm_source=hero&utm_campaign=deals_der_woche&utm_content=cta_B'
      }
    };

    var picked = variants[variant] || variants.A;
    primary.textContent = picked.label;
    primary.setAttribute('href', picked.href);
    primary.dataset.ocHeroVariant = variant;

    primary.addEventListener('click', function () {
      track('hero_cta_click', { variant: variant, href: picked.href, label: picked.label });
    });

    if (heroButtons[1]) {
      heroButtons[1].addEventListener('click', function () {
        track('hero_secondary_cta_click', {
          href: heroButtons[1].getAttribute('href') || '',
          label: (heroButtons[1].textContent || '').trim()
        });
      });
    }

    var announcementLink = document.querySelector('#shopify-section-sections--header-group .announcement-bar a');
    if (announcementLink) {
      announcementLink.addEventListener('click', function () {
        track('announcement_campaign_click', { href: announcementLink.getAttribute('href') || '' });
      });
    }
  });
})();


(function () {
  function ready(fn){ if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function track(eventName, payload){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event:eventName}, payload||{}));
      if (typeof window.gtag === 'function') window.gtag('event', eventName, payload||{});
    } catch(e){}
  }
  ready(function(){
    var checkoutBtn = document.querySelector('#checkout.cart__checkout-button');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function(){
        track('checkout_click', {source:'cart_page'});
      });
    }
  });
})();


/* OpenClaw Impact Sprint v2: Hero + Announcement A/B */
(function () {
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function track(eventName, payload){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event:eventName}, payload || {}));
      if (typeof window.gtag === 'function') window.gtag('event', eventName, payload || {});
    } catch(e){}
  }

  ready(function(){
    var heroButtons = document.querySelectorAll('main .banner .banner__buttons a.button');
    if (!heroButtons || !heroButtons.length) return;

    var heroVariants = {
      A: {
        label: 'Deals bis Sonntag sichern',
        href: '/collections/deals-der-woche?utm_source=onsite&utm_medium=hero&utm_campaign=weekend_boost&utm_content=hero_A_deadline'
      },
      B: {
        label: 'Top Deals unter 100€',
        href: '/collections/top-20-unter-100?utm_source=onsite&utm_medium=hero&utm_campaign=weekend_boost&utm_content=hero_B_under100'
      }
    };

    var heroKey='oc_hero_cta_variant_v2';
    var hv=localStorage.getItem(heroKey);
    if(!hv){ hv=Math.random()<0.5?'A':'B'; localStorage.setItem(heroKey,hv); }
    var hero=heroVariants[hv] || heroVariants.A;

    var primary=heroButtons[0];
    primary.textContent=hero.label;
    primary.setAttribute('href', hero.href);
    primary.dataset.ocHeroVariant=hv;
    track('hero_cta_variant_seen', {variant: hv, href: hero.href, label: hero.label});

    primary.addEventListener('click', function(){
      track('hero_cta_click_v2', {variant: hv, href: hero.href, label: hero.label});
    });

    var ann = document.querySelector('#shopify-section-sections--header-group .announcement-bar a');
    var annVariants = {
      A: {
        text: '⚡ Weekend Boost: Deals bis Sonntag 23:59 sichern',
        href: '/collections/deals-der-woche?utm_source=onsite&utm_medium=announcement&utm_campaign=weekend_boost&utm_content=ann_A_deadline'
      },
      B: {
        text: '🔥 Bestseller + Deals: Nur kurze Zeit live',
        href: '/collections/bestseller-singles?utm_source=onsite&utm_medium=announcement&utm_campaign=weekend_boost&utm_content=ann_B_bestseller'
      }
    };

    if (ann) {
      var annKey='oc_ann_variant_v2';
      var av=localStorage.getItem(annKey);
      if(!av){ av=Math.random()<0.5?'A':'B'; localStorage.setItem(annKey,av); }
      var annSel=annVariants[av] || annVariants.A;
      ann.textContent = annSel.text;
      ann.setAttribute('href', annSel.href);
      ann.dataset.ocAnnVariant=av;
      track('announcement_variant_seen', {variant: av, href: annSel.href, text: annSel.text});
      ann.addEventListener('click', function(){
        track('announcement_click_v2', {variant: av, href: annSel.href});
      });
    }
  });
})();
